import "./Embed.css";
import Player from "../components/Player"
import { useParams } from "react-router";

export default function Embed (){
    let { id, app } = useParams();
    return <Player app={app} id={id}></Player>;
}